<div class="container-fluid" >
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <div class="page-title-right">
              <a class="btn btn-primary" (click)="volver()">
                Volver
              </a>
            </div>
            <h3 class="page-title">Documentos aspirante | {{nombre_participante}}</h3>
        </div>
    </div>
  </div>

  <hr class="text-dark">
  <div class="container-fluid">
    <div class="row mb-3">
      <div class="col-12">
        <h5>Expediente Digital</h5>
      </div>
    </div>
    <div class="row g-3 container-fluid">
      <ol>
        <li class="mb-2">
          <div class="row">
            <div class="col-md-12 mt-3">
              <h5> Notas certificadas del último año de estudio aprobado.&nbsp;&nbsp; </h5>
            </div>
            <div class="col-md-12 mt-3 text-center" *ngIf="valNotas">
              <embed id="imgNotas" [src]="valNotas" type="application/pdf" width="70%" height="400px"/>
            </div>
            <div class="col-md-12 mt-3" *ngIf="!valNotas">
              <h5 class="text-danger">No ha cargado documento!</h5>
            </div>
          </div>
        </li>

        <hr class="text-dark">

        <li class="mb-2">
          <div class="row">
            <div class="col-md-12 mt-3">
              <h5> Comprobante de aprobación de 6to grado.&nbsp;&nbsp; </h5>
            </div>
            <div class="col-md-12 mt-3 text-center" *ngIf="valConstancia">
              <embed id="imgConstancia" [src]="valConstancia" type="application/pdf" width="70%" height="400px"/>
            </div>
            <div class="col-md-12 mt-3" *ngIf="!valConstancia">
              <h5 class="text-danger">No ha cargado documento!</h5>
            </div>
          </div>
        </li>

        <hr class="text-dark">

        <li class="mb-2">
          <div class="row">
            <div class="col-md-12 mt-3">
              <h5> Fotografía tipo carnet (26x32 mm).&nbsp;&nbsp; </h5>
            </div>
            <div class="col-md-12 mt-3 text-center" *ngIf="valFotografia">
              <embed id="imgFotografia" [src]="valFotografia" type="application/pdf" width="70%" height="400px"/>
            </div>
            <div class="col-md-12 mt-3" *ngIf="!valFotografia">
              <h5 class="text-danger">No ha cargado documento!</h5>
            </div>
          </div>
        </li>

        <hr class="text-dark">

        <li class="mb-2">
          <div class="row">
            <div class="col-md-12 mt-3">
              <h5> Acta de nacimiento.&nbsp;&nbsp; </h5>
            </div>
            <div class="col-md-12 mt-3 text-center" *ngIf="valCarnet">
              <embed id="imgCarnet" [src]="valCarnet" type="application/pdf" width="70%" height="400px"/>
            </div>
            <div class="col-md-12 mt-3" *ngIf="!valCarnet">
              <h5 class="text-danger">No ha cargado documento!</h5>
            </div>
          </div>
        </li>

        <hr class="text-dark">

        <li class="mb-2">
          <div class="row">
            <div class="col-md-12 mt-3">
              <h5> Documento de identidad.&nbsp;&nbsp; </h5>
            </div>
            <div class="col-md-12 mt-3 text-center" *ngIf="valCedula">
              <embed id="imgCedula" [src]="valCedula" type="application/pdf" width="70%" height="400px"/>
            </div>
            <div class="col-md-12 mt-3" *ngIf="!valCedula">
              <h5 class="text-danger">No ha cargado documento!</h5>
            </div>
          </div>
        </li>

        <hr class="text-dark">

        <li class="mb-2">
          <div class="row">
            <div class="col-md-12 mt-3">
              <h5> Notas certificadas del último año de estudio aprobado.&nbsp;&nbsp; </h5>
            </div>
            <div class="col-md-12 mt-3 text-center" *ngIf="valRepresentante">
              <embed id="imgRepresentante" [src]="valRepresentante" type="application/pdf" width="70%" height="400px"/>
            </div>
            <div class="col-md-12 mt-3" *ngIf="!valRepresentante">
              <h5 class="text-danger">No ha cargado documento!</h5>
            </div>
          </div>
        </li>

        <hr class="text-dark">

        <li class="mb-2">
          <div class="row">
            <div class="col-md-12 mt-3">
              <h5> Comprobante de aprobación de 6to grado.&nbsp;&nbsp; </h5>
            </div>
            <div class="col-md-12 mt-3 text-center" *ngIf="valSalud">
              <embed id="imgSalud" [src]="valSalud" type="application/pdf" width="70%" height="400px"/>
            </div>
            <div class="col-md-12 mt-3" *ngIf="!valSalud">
              <h5 class="text-danger">No ha cargado documento!</h5>
            </div>
          </div>
        </li>

        <hr class="text-dark">

        <li class="mb-2">
          <div class="row">
            <div class="col-md-12 mt-3">
              <h5> Fotografía tipo carnet (26x32 mm).&nbsp;&nbsp; </h5>
            </div>
            <div class="col-md-12 mt-3 text-center" *ngIf="valRif">
              <embed id="imgRif" [src]="valRif" type="application/pdf" width="70%" height="400px"/>
            </div>
            <div class="col-md-12 mt-3" *ngIf="!valRif">
              <h5 class="text-danger">No ha cargado documento!</h5>
            </div>
          </div>
        </li>

        <hr class="text-dark">

        <li class="mb-2">
          <div class="row">
            <div class="col-md-12 mt-3">
              <h5> Acta de nacimiento.&nbsp;&nbsp; </h5>
            </div>
            <div class="col-md-12 mt-3 text-center" *ngIf="valCurriculum">
              <embed id="imgCurriculum" [src]="valCurriculum" type="application/pdf" width="70%" height="400px"/>
            </div>
            <div class="col-md-12 mt-3" *ngIf="!valCurriculum">
              <h5 class="text-danger">No ha cargado documento!</h5>
            </div>
          </div>
        </li>

        <hr class="text-dark">

        <li class="mb-2">
          <div class="row">
            <div class="col-md-12 mt-3">
              <h5> Documento de identidad.&nbsp;&nbsp; </h5>
            </div>
            <div class="col-md-12 mt-3 text-center" *ngIf="valReferencia">
              <embed id="imgReferencia" [src]="valReferencia" type="application/pdf" width="70%" height="400px"/>
            </div>
            <div class="col-md-12 mt-3" *ngIf="!valReferencia">
              <h5 class="text-danger">No ha cargado documento!</h5>
            </div>
          </div>
        </li>

        <hr class="text-dark">

        <li class="mb-2">
          <div class="row">
            <div class="col-md-12 mt-3">
              <h5> Documento de identidad.&nbsp;&nbsp; </h5>
            </div>
            <div class="col-md-12 mt-3 text-center" *ngIf="valLopna">
              <embed id="imgLopna" [src]="valLopna" type="application/pdf" width="70%" height="400px"/>
            </div>
            <div class="col-md-12 mt-3" *ngIf="!valLopna">
              <h5 class="text-danger">No ha cargado documento!</h5>
            </div>
          </div>
        </li>
      </ol>
    </div>




  </div>

</div>

<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>
